import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/sys/user"


const sysUser = {
  userLoginDetails() {
    return axios.get(pre + `/userLoginDetails`);
  },
  userPageList(pageSize, limit, keyWord) {
    return axios.get(pre + `/userPageList`,
      {
        params: {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord
        }
      });
  },
  getUserInfo(id) {
    return axios.get(pre + `/getUserInfo`, {params: {id: id}});
  },

  frozenUser(id) {
    return axios.post(pre + `/frozenUser`, qs.stringify({id: id}));
  },

  addOrUpdate(params) {
    return axios.post(pre + `/addOrUpdate`, qs.stringify(params));
  },
}
export default sysUser;



// WEBPACK FOOTER //
// ./src/api/sys/user.js